import React, {
  useContext,
} from 'react';

import MmmLogo from '@tmap/mmm-style-guide/src/svg/MmmLogo';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { IconButton } from '@tmap/mmm-style-guide/src/IconButton';
import { Drawer } from '@tmap/mmm-style-guide/src/Drawer';
import {
  Close,
} from '@tmap/mmm-style-guide/src/Icon';

import HeaderContext from './HeaderContext';
import RelocNavGroup from './relocNavGroup';
import { Logout, SignInSignUp } from './authButtons';

const DrawerRootGrid = styled(Grid)(({ theme, spacing }) => ({
  height: `calc(100% + ${theme.spacing(spacing)})`,
}));

const CloseIcon = styled(Close)(({ theme }) => ({
  fontSize: '24px',
  color: theme.palette.text.secondary,
}));

const CloseIconButton = styled(IconButton)(() => ({
  padding: '4px',
}));

export default function HeaderDrawer() {
  const {
    isMenuOpen,
    handleCloseMenu,
    isAuthenticated,
    hasCommunity,
    headerDrawerSx,
  } = useContext(HeaderContext);
  return (
    <Drawer
      anchor='right'
      open={isMenuOpen}
      onClose={handleCloseMenu}
      sx={headerDrawerSx}
    >
      <DrawerRootGrid
        container
        direction='column'
        flexWrap='nowrap'
        justifyContent='space-between'
        spacing={0}
        paddingTop={1}
      >
        <Grid item>
          <Grid container direction='column' spacing={2}>
            <Grid item>
              <Grid
                container
                flexWrap='nowrap'
                justifyContent='space-between'
                spacing={2}
                paddingLeft={2}
                paddingRight={1}
              >
                <Grid item display='flex' alignItems='center'>
                  <MmmLogo size={20} />
                </Grid>
                <Grid item>
                  <CloseIconButton padding={1} onClick={handleCloseMenu}>
                    <CloseIcon />
                  </CloseIconButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container direction='column'>
                <RelocNavGroup location='first' />
                <RelocNavGroup location='browse' />
                {hasCommunity && (
                  <RelocNavGroup location='communities' />
                )}
                <RelocNavGroup location='resources' />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction='column' spacing={1}>
            <RelocNavGroup location='final' />
            {isAuthenticated ? (
              <Grid item>
                <Box paddingX={2} paddingBottom={2}>
                  <Logout />
                </Box>
              </Grid>
            ) : (
              <Grid item>
                <Box paddingX={2} paddingBottom={2}>
                  <SignInSignUp />
                </Box>
              </Grid>
            )}
          </Grid>
        </Grid>
      </DrawerRootGrid>
    </Drawer>
  );
}
